import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuthContext } from './AuthContext';
import { playNotificationSoundDouble, playNotificationWithBrowserAPI } from '../utils/sound';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const { user, token } = useAuthContext();
  const [socket, setSocket] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user && token) {
      const socketUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5001';
      const newSocket = io(socketUrl, {
        auth: { token },
        transports: ['websocket']
      });

      newSocket.on('connect', () => {
        console.log('🔌 Connected to Socket server');
      });

      newSocket.on('new_notification', (notification) => {
        console.log('🔔 New notification received:', notification);
        
        // Play sound
        playNotificationSoundDouble();
        
        // Show browser notification
        playNotificationWithBrowserAPI(notification.message || 'New notification');

        setNotifications((prev) => [notification, ...prev]);
        setUnreadCount((prev) => prev + 1);
      });

      newSocket.on('connect_error', (err) => {
        console.error('❌ Socket connection error:', err.message);
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
        console.log('🔌 Socket connection closed');
      };
    }
  }, [user, token]);

  const value = {
    socket,
    notifications,
    setNotifications,
    unreadCount,
    setUnreadCount
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};
